import React, {useState} from "react";
import { Form, InputGroup } from 'react-bootstrap';
import "./MapFilter.css";
import { FaSearch } from 'react-icons/fa';
import CloseButton from "../CloseButton/CloseButton";

const NewMapFilter = ({ onStatusChange, setSearchValue, onClose, selectedStatuses }) => {
    // const [searchValue, setSearchValue] = useState("");
    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
    };
    const handleCheckboxChange = (event) => {
      const { id, checked } = event.target;
      const status = parseInt(id); // Convert checkbox ID to integer status
      onStatusChange(status, checked);
    };

    return (<>
        <div className="filter-container">
            <div className="d-flex justify-content-between align-items-center">
                <h4 className="filter-heading">FILTER</h4>
                <CloseButton onClick={onClose} />
            </div>
            <hr />
            <div className="search-bar">
                <InputGroup>
                    <InputGroup.Text className="search-icon">
                        <FaSearch />
                    </InputGroup.Text>
                    <Form.Control
                        type="text"
                        placeholder="Search by Building Name"
                        className="search-input"
                        onChange={handleSearchChange}
                    />
                </InputGroup>
            </div>
            <hr />
            <div>
                <h5 className="status-heading">STATUS</h5>
                <div className="checkbox-list">
                    <Form.Check
                        type="checkbox"
                        label="Offline"
                        id="10"
                        className="checkbox"
                        checked={selectedStatuses.includes(10)}
                        onChange={handleCheckboxChange}
                    />
                    <Form.Check
                        type="checkbox"
                        label="Running"
                        id="20"
                        className="checkbox"
                        checked={selectedStatuses.includes(20)}
                        onChange={handleCheckboxChange}
                    />
                    <Form.Check
                        type="checkbox"
                        label="Guarded"
                        id="30"
                        className="checkbox"
                        checked={selectedStatuses.includes(30)}
                        onChange={handleCheckboxChange}
                    />
                    <Form.Check
                        type="checkbox"
                        label="Alarm"
                        id="40"
                        className="checkbox"
                        checked={selectedStatuses.includes(40)}
                        onChange={handleCheckboxChange}
                    />
                    <Form.Check
                        type="checkbox"
                        label="Emergency"
                        id="50"
                        className="checkbox"
                        checked={selectedStatuses.includes(50)}
                        onChange={handleCheckboxChange}
                    />
                    <Form.Check
                        type="checkbox"
                        label="Shutdown"
                        id="60"
                        className="checkbox"
                        checked={selectedStatuses.includes(60)}
                        onChange={handleCheckboxChange}
                    />
                </div>
            </div>
        </div >
    </>)
}

export default NewMapFilter
